module.exports = __webpack_public_path__ + "static/media/productLogos.8e82aeec.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/productLogos.png
// module id = 987
// module chunks = 0